import { render, staticRenderFns } from "./template-tester.vue?vue&type=template&id=31e09e83&scoped=true"
import script from "./template-tester.vue?vue&type=script&lang=js"
export * from "./template-tester.vue?vue&type=script&lang=js"
import style0 from "./template-tester.vue?vue&type=style&index=0&id=31e09e83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e09e83",
  null
  
)

export default component.exports